import { Integration } from '../../../../shared/interfaces/integration';
import { OperandValue } from '../../../../shared/utils/filters';
import { PIPELINE_RENDERED_STATUSES_VALUES } from '../../../../pipelines/constants/pipeline-status';

export const SEARCH_FILTER_KEY = 'term';

export const getFilterKeyMatchValue = (filterKey: string, item: Integration): OperandValue => {
  switch (filterKey) {
    case 'destination_name':
      return item.destination?.name;
    case 'status':
      return PIPELINE_RENDERED_STATUSES_VALUES[item.status.value];
    case SEARCH_FILTER_KEY:
      return [item.name, item.source?.name || '', item.destination?.name || ''];
    default:
      return undefined;
  }
};

export const getSortValue = (item: Integration, field: string) => {
  if (field === 'id') {
    return item.id;
  }

  return item.name.trim().toLowerCase();
};
